import {Trans, useTranslation} from "ni18n";
import React from "react";
import {V5Img} from "src/components/_common/Carbon";
import {useCarbonForCampusConstants} from "src/constants/CarbonForCampus";
import useMediaQuery from "src/useMediaQuery";

import {IllustratedTextDecoration} from "../IllustratedTextDecoration";
import {Btn} from "../V5Comp";

const Overview: React.FC = () => {
  const i18n = useTranslation();

  const {data, ctaProps} = useCarbonForCampusConstants();

  const isXs = useMediaQuery("xs");

  return (
    <div className="ph8 pt12 pb24">
      <div className="maxw80 ma">
        <h2 className="maxw30 mb4 fs40 fs32-xs">
          <Trans>
            A healthcare program{" "}
            <span className="darkerYellow">
              tailored for{" "}
              <span className="pos-r zIndex1">
                students{" "}
                <IllustratedTextDecoration
                  type="yellow-underline"
                  style={{bottom: -5}}
                  className="dn-xs"
                />
              </span>
            </span>
          </Trans>
        </h2>
        <p className="maxw40 font-cm dn-sm">
          {i18n.t(
            "We understand that the needs of students differ from the needs of the general population. Our work with universities has allowed us to develop a uniquely student-centric program.",
          )}
        </p>
        <div className="dg-xs gg6-xs">
          {data.map(section => (
            <div key={section.img} className="df fdc-sm mt40 mt0-xs">
              <div className="df fx jcc-sm">
                <V5Img src={section.img} alt={section.alt} className="h120 h100-md h72-sm" />
              </div>
              <div className="fx pos-r pt10">
                <V5Img
                  src="/illustrated-arrow-purple"
                  className="pos-a h18 w22 dn-sm"
                  style={{top: -50, ...section.arrowStyle}}
                />
                <h3 className="fs28 fs20-xs font-cb">{section.header}</h3>
                <ul className="pl14 pl10-xs mt4">
                  {section.list.map(item => (
                    <li key={item.header} className="pos-r mb6">
                      <span
                        className="cIcon-illustrated-check pos-a fs22 fs16-xs"
                        style={{left: isXs ? -32 : -50, top: 3}}
                      />
                      <h4 className="fs18 mb2 ls-3">{item.header}</h4>
                      <p className="font-ir">{item.text}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
        <div className="df fdc aic mt32 mt20-sm">
          <div className="fs60 fs48-xs font-csb mb4">{i18n.t("We can help.")}</div>
          <Btn {...ctaProps} className="focus-bsDarkBlue3" />
        </div>
      </div>
    </div>
  );
};

export default Overview;
